<template>
  <div class="container">
    <h1>Create Object</h1>
    <div class="container has-text-left">
      <div class="block">
        <b-field label="Integration">
          <b-select v-model="integrationId">
            <option
                v-for="integration in integrations"
                :key="integration.id"
                :value="integration.id"
            >{{integration.name}}</option>
          </b-select>
        </b-field>
        <b-field label="Device" v-if="integrationId > 0">
          <b-select v-model="deviceId">
            <option v-for="device in devices"
                    :key="device.id"
                    :value="device.id"
            >{{device.name}}</option>
          </b-select>
        </b-field>
        <b-field label="Topic" v-if="integrationId > 0 && deviceId > 0">
          <b-select v-model="topicId">
            <option v-for="topic in availableTopics"
                    :key="topic.id"
                    :value="topic.id"
            >{{topic.topic}}</option>
          </b-select>
        </b-field>
        <b-field label="Name" v-if="topicId > 0">
          <b-input v-model="objectName" placeholder="Enter object name..." required></b-input>
        </b-field>
        <b-field label="Object Type" v-if="topicId > 0">
          <b-select v-model="objectTypeId">
            <option v-for="objectType in objectTypes"
                    :key="objectType.id"
                    :value="objectType.id"
            >{{objectType.name}}</option>
          </b-select>
        </b-field>
        <b-field label="Value Suffix" v-if="topicId > 0 && objectTypeId > 0">
          <b-input v-model="objectSuffix" placeholder="Value suffix (optional)..."></b-input>
        </b-field>
        <b-field label="Graph Template">
          <b-select v-model="graphTemplateId">
            <option value="0">Select one...</option>
            <option
                v-for="graphTemplate in graphTemplates"
                :key="graphTemplate.id"
                :value="graphTemplate.id"
            >{{graphTemplate.name}}</option>
          </b-select>
        </b-field>
      </div>
      <div class="buttons">
        <b-button type="is-success" :disbled="!validFields()" @click="handleCreateObject">Create Object</b-button>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex';
  import BField from "buefy/src/components/field/Field";
  import BSelect from "buefy/src/components/select/Select";
  import BInput from "buefy/src/components/input/Input";
  import BButton from "buefy/src/components/button/Button";

  export default {
    name: "screenconfigurewizardobject",
    components: {
      BButton,
      BInput,
      BSelect,
      BField

    },
    data() {
      return {
        integrationId: 0,
        deviceId: 0,
        topicId: 0,
        device: null,
        objectName: '',
        objectTypeId: 27,
        objectSuffix: '',
        graphTemplateId: 0
      };
    },
    watch: {
      topicId() {
        this.objectName = this.computedObjectName;
      }
    },
    computed: {
      ...mapGetters('ui', ['loadingOverlay']),
      ...mapGetters('devices', ['devices', 'deviceById', 'deviceByTopicId', 'deviceTopics', 'topicsByDeviceId', 'deviceTopicById']),
      ...mapGetters('integrations', ['integrations']),
      ...mapGetters('objects', ['objectTypes']),
      ...mapGetters('graphs', ['graphTemplates']),
      availableTopics() {
        if (this.deviceId > 0) {
          return this.topicsByDeviceId(this.deviceId);
        }

        return [];
      },
      computedObjectName() {
        if (this.topicId > 0) {
          const selectedTopic = this.deviceTopicById(this.topicId);
          if (selectedTopic) {
            const splits = selectedTopic.topic.split(/\//g);
            if (splits.length > 1) {
              let retVal = `${this.device.name} ${splits[splits.length - 2]}`;
              if (splits[splits.length - 1].toLowerCase().startsWith('timestamp')) {
                return `${retVal} Timestamp`;
              }

              return retVal;
            }
          }
        }
        return '';
      }
    },
    methods: {
      ...mapActions('objects', ['createObject']),
      validFields() {
        return this.topicId > 0 && this.objectName.length > 0 && this.objectTypeId > 0;
      },
      handleCreateObject() {
        this.createObject({
          name: this.objectName,
          typeId: parseInt(this.objectTypeId),
          suffix: this.objectSuffix.trim(),
          topicId: this.topicId,
          graphTemplateId: this.graphTemplateId,
          callback: (objectId) => {
            this.$router.push('/configure/objects/' + objectId);
          }
        });
      }
    },
    mounted() {
      const {topicId} = this.$route.params;
      if (topicId && parseInt(topicId) > 0) {
        this.topicId = parseInt(topicId);
        this.device = this.deviceByTopicId(this.topicId);
        if (this.device) {
          this.integrationId = this.device.integration_id;
          this.deviceId = this.device.id;
        }
      }
    }
  }
</script>

<style scoped>

</style>